import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useDriver({ driverId, onSuccess }) {
  const { data, ...rest } = useQuery(
    'driver',
    () => apiCalls.getDriversV2({ driverId }).then(({ data: { drivers } }) => drivers[0]),
    {
      enabled: !!driverId,
      onSuccess: (data) => {
        onSuccess(data);
      },
    }
  );
  return { driver: data, ...rest };
}

export function useDrivers() {
  const { data, ...rest } = useQuery('drivers', () =>
    apiCalls.getDriversV2({}).then(({ data: { drivers, totalCount } }) => ({ drivers, totalCount }))
  );
  return { result: data, ...rest };
}

export function useDriverCreate(onSuccess) {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ driver }) => apiCalls.createDriverV2({ driver }), {
    onSuccess: (driver) => {
      queryClient.invalidateQueries('drivers');
      onSuccess(driver);
    },
  });
  return { createDriver: mutate, ...rest };
}

export function useDriverEdit(onSuccess) {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ driver }) => apiCalls.editDriverV2({ driver }), {
    onSuccess: (driver) => {
      queryClient.invalidateQueries('drivers');
      onSuccess(driver);
    },
  });
  return { editDriver: mutate, ...rest };
}

export function useDriverDelete() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ driver }) => apiCalls.deleteDriver({ driverId: driver.id }), {
    onSuccess: () => {
      queryClient.invalidateQueries('drivers');
    },
  });
  return { deleteDriver: mutate, ...rest };
}
